
import { useContext } from 'react'
import { AppMainContext } from '../context/AppMainContext';
import { useNavigate } from 'react-router-dom';

export default function SignUp() {
    const { signupFlag, setSignupName, setSignupPass, handleSignup } = useContext(AppMainContext);

    const nav = useNavigate();
  return (
    <div className="signForm_page">
        <div className="signForm_div">
            <h1 className="signForm_header">הרשמה</h1>
            <div className="signForm_inputs">
                <input className="signForm_input" type='text' placeholder='שם משתמש' onChange={(e)=>{setSignupName(e.target.value)}}/>
                <input className="signForm_input" type='text' placeholder='סיסמא' onChange={(e)=>{setSignupPass(e.target.value)}}/>
            </div>
            <button className="signForm_btn" disabled={signupFlag} onClick={()=>{handleSignup(nav)}}>{signupFlag ? "המתן..." : "תרשום אותי"}</button>
        </div>
        <div className="signForm_linkDiv">
            <p className="signForm_link_p">להתחברות לחץ <a className="signForm_link_a" href="/">כאן</a></p>
        </div>
    </div>
  )
}
